export interface ICondition {
    /**
     * The condition is met for entities that are direct or indirect descendants of the entities with the specified ids.
     * The entities are combined using the "OR" operator.
     */
    entityIds: Array<number>;

    /**
     * The condition is met for entities that are direct descendants of the entities with the specified ids.
     * The entities are combined using the "OR" operator.
     */
    directEntityIds: Array<number>;
}

export class Condition implements ICondition {
    entityIds: Array<number> = [];
    directEntityIds: Array<number> = [];
}
